import React from "react";
import { GeoJSONLayer } from "react-mapbox-gl";
import PropTypes from "prop-types";

const MyMapBoxDirection = ({ fleetIds, coords, colors }) => {
  return (
    <GeoJSONLayer
      data={{
        type: "FeatureCollection",
        features: fleetIds.reduce((res, fleetId) => {
          if (!!coords[fleetId]) {
            res.push({
              type: "Feature",
              properties: { color: `#${colors[fleetId]}` },
              geometry: {
                type: "LineString",
                coordinates: coords[fleetId].map((c) => [c.lng, c.lat]),
              },
            });
          }
          return res;
        }, []),
      }}
      linePaint={{
        "line-color": ["get", "color"],
        "line-width": 3,
        "line-opacity": 1,
      }}
    />
  );
};

MyMapBoxDirection.propTypes = {
  fleetIds: PropTypes.array.isRequired,
  coords: PropTypes.object.isRequired,
  colors: PropTypes.object.isRequired,
};

export default React.memo(MyMapBoxDirection);
